export enum ScoringRiskType {
	None = 'None',
	Low = 'Low',
	Moderate = 'Moderate',
	High = 'High',
	Strong = 'Strong',
}
